var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.719.625C6.039.625.625 6.04.625 12.719S6.04 24.812 12.719 24.812s12.094-5.414 12.094-12.093S19.398.625 12.719.625M5.98 4.788a10.37 10.37 0 0 1 6.738-2.476c5.747 0 10.406 4.66 10.406 10.407 0 2.57-.931 4.922-2.475 6.737zM4.788 5.98a10.37 10.37 0 0 0-2.476 6.738c0 5.747 4.66 10.406 10.407 10.406 2.57 0 4.922-.932 6.737-2.475z",
    clipRule: "evenodd"
  })));
};
export default SvgIconClose;